import { Component } from '../core/component.js';
import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { PaymentType } from '../../models/serializable/payment-type.js';
import { toEnumFromString } from '../../serialization/enum-utils.js';

export class LegacyBusinessPaymentComponent extends Component {
  static readonly TYPE_ID: string = 'fe93698787814a5291014033545519d8';

  constructor(
    public readonly paymentMethods: PaymentType[],
  ) {
    super();
  }

  get $typeId() {
    return LegacyBusinessPaymentComponent.TYPE_ID;
  }

  get $removable() {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacyBusinessPaymentComponent {
    return new LegacyBusinessPaymentComponent(
        MapUtils.getList<PaymentType>(
            map,
            'paymentMethods',
            (value) => toEnumFromString(
                value as string,
                PaymentType,
            ) ?? PaymentType.OnDelivery),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'paymentMethods': this.paymentMethods,
    };
  }

  clone(): this {
    return new LegacyBusinessPaymentComponent(
        this.paymentMethods,
    ) as this;
  }

  isSame(other: LegacyBusinessPaymentComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameList(other.paymentMethods, this.paymentMethods);
  }
}

export class LegacyBusinessPaymentComponentBuilder extends DataModelBuilder<LegacyBusinessPaymentComponent> {
  build(context: SerializationContext, map: SerializedData): LegacyBusinessPaymentComponent {
    return LegacyBusinessPaymentComponent.fromMap(context, map);
  }
}
